import { render } from "./BodyFarmlist.vue?vue&type=template&id=f36a2bce"
import script from "./BodyFarmlist.vue?vue&type=script&lang=js"
export * from "./BodyFarmlist.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/reports/windowOverlay/reportInfo/BodyFarmlist.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f36a2bce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f36a2bce', __exports__)) {
    api.reload('f36a2bce', __exports__)
  }
  
  module.hot.accept("./BodyFarmlist.vue?vue&type=template&id=f36a2bce", () => {
    api.rerender('f36a2bce', render)
  })

}


export default __exports__